import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { supabase } from '../../lib/supabase'
import Loader from '../../components/Loader'
import '../onboarding/onboarding.css'
import './settings.css'

const SettingsChangePassword = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const onBack = () => navigate('/app/profile/settings/account')

  const onSave = async (e) => {
    e.preventDefault()
    setError('')
    const trimmed = newPassword.trim()
    if (trimmed !== newPassword || /\s/.test(newPassword)) {
      setError(t('changePassword.passwordNoSpaces'))
      return
    }
    if (newPassword.length < 6) {
      setError(t('loginPassword.passwordMinLength'))
      return
    }
    if (newPassword.length > 50) {
      setError(t('changePassword.passwordNoSpaces'))
      return
    }
    if (confirmPassword.trim() !== confirmPassword || /\s/.test(confirmPassword)) {
      setError(t('changePassword.passwordNoSpaces'))
      return
    }
    if (newPassword !== confirmPassword) {
      setError(t('changePassword.passwordsNoMatch'))
      return
    }
    setSaving(true)
    const { error: err } = await supabase.auth.updateUser({ password: newPassword })
    setSaving(false)
    if (err) {
      setError(err.message || t('changePassword.updateFailed'))
      return
    }
    setSuccess(true)
    setNewPassword('')
    setConfirmPassword('')
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← {t('common.back')}</button>
        </div>
        <h1 className="h1">{t('changePassword.title')}</h1>
        {success ? (
          <p className="p" style={{ color: 'var(--gray)' }}>{t('changePassword.passwordUpdated')}</p>
        ) : (
          <>
            <form onSubmit={onSave}>
              <div className="field">
                <label className="label">{t('changePassword.newPasswordLabel')}</label>
                <input
                  className="input"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="new-password"
                />
              </div>
              <div className="field">
                <label className="label">{t('changePassword.confirmNewPasswordLabel')}</label>
                <input
                  className="input"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="new-password"
                />
              </div>
              {error && <p className="p" style={{ color: '#c00', marginBottom: 12 }}>{error}</p>}
              <button
                type="submit"
                className="settings-modal-btn settings-modal-btn-primary"
                style={{ width: '100%' }}
                disabled={saving}
              >
                {saving ? <Loader text={t('changePassword.saving')} inline /> : t('common.save')}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  )
}

export default SettingsChangePassword
